<template>
  <div class="checkbox" @click.stop="emitClick">
    <label class="checkbox__inner">
      <input type="checkbox" v-model="isChecked" />
      <span class="checkbox__box" @click="emitClick">
        <svg
          class="checkbox__box-mark"
          width="10"
          height="9"
          viewBox="0 0 10 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.56923 0.177898C10.0233 0.492264 10.1366 1.11522 9.82221 1.5693L4.69108 8.98093L0.349227 5.25935C-0.0700991 4.89993 -0.118661 4.26862 0.240762 3.8493C0.600184 3.42997 1.23148 3.38141 1.65081 3.74083L4.30896 6.01925L8.17783 0.43088C8.49219 -0.0232038 9.11514 -0.136468 9.56923 0.177898Z"
            fill="#F2F2F2"
          />
        </svg>
      </span>
      <span class="checkbox__text">
        {{ switcherLabel }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'CheckboxInput',
  model: {
    prop: 'checked',
    event: 'update',
  },
  props: {
    label: {
      type: [String, Array],
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChecked: false,
      initialDataLoaded: false,
    }
  },
  created() {
    this.isChecked = this.checked

    this.$nextTick(() => {
      this.initialDataLoaded = true
    })
  },
  watch: {
    checked: function () {
      this.isChecked = this.checked
    },
    isChecked: function () {
      if (this.initialDataLoaded) {
        this.$emit('update:value', this.isChecked)
      }
    },
  },
  computed: {
    switcherLabel: function () {
      if (Array.isArray(this.label)) {
        return this.isChecked ? this.label[0] : this.label[1]
      } else {
        return this.label
      }
    },
  },
  methods: {
    emitClick: function () {
      this.$emit('click')
    },
  },
  emits: ['update:value', 'click'],
}
</script>

<style lang="scss" scoped>
.checkbox {

	&__inner {
		width: 100%;
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	&__box {
		display: flex;
		align-items: center;
		justify-content: center;

		width: 20px;
		height: 20px;
		flex-shrink: 0;
		flex-grow: 0;
		margin-right: 13px;

		background: #e0e6f2;
		border: 2px solid #b9c4d8;
		border-radius: 5px;
		transition: background 0.2s linear, border-color 0.2s linear;

		&-mark {
			max-width: 100%;
			max-height: 100%;
			opacity: 0;
			transition: opacity 0.2s linear;
		}
	}

	&__text {
		font-weight: 500;
		font-size: 12px;
		line-height: 20px;
		color: #585f6d;
	}

	input {
		display: none;
	}

	input:checked + &__box {
		background: #64748B;
		border-color: #64748B;

		.checkbox {
			&__box {
				&-mark {
					opacity: 1;
				}
			}
		}
	}
}
</style>
